import React, {FC} from 'react'

import Stars from '@/components/stars'
import RichText, {Props as RichTextProps} from '@helios/shared/components/rich-text'
import {Layout} from '@helios/shared/styles/grid'
import {colors} from '@helios/shared/theme'
import ImageSource from '@helios/shared/types/image'
import hasNonEmptyItems from '@helios/shared/utils/has-non-empty-items'

import * as s from './title-with-icon-grid.styles'

interface Item {
    icon: ImageSource
    stars?: string
}

export interface Props {
    title: RichTextProps['content']
    items: Item[]
    large?: boolean
    highlightColor?: keyof typeof colors.background
    dataTestId?: string
}

const TitleWithIconGridSection: FC<Props> = ({
    children,
    title,
    items,
    large,
    highlightColor,
    dataTestId,
}) => (
    <Layout
        as={s.Wrapper}
        variant="two-asymmetrical"
        alignItems="center"
        highlightColor={highlightColor}
        dataTestId={dataTestId}
    >
        <s.ContentWrapper>
            <RichText size={large ? 'xl' : 'md'} as="h2" content={title} />

            {children}
        </s.ContentWrapper>

        {hasNonEmptyItems(items) && (
            <s.Icons $twoCol={items.length <= 4}>
                {items.map((item, i) => (
                    <s.IconWrapper key={`${item.icon?.url}-${i}`}>
                        <s.Icon image={item.icon} height={60} />

                        {item.stars && <Stars numberOfStars={Number(item.stars)} />}
                    </s.IconWrapper>
                ))}
            </s.Icons>
        )}
    </Layout>
)

export default TitleWithIconGridSection
